import { clienteAxiosSaaSLog } from "../axios";

/**
 * Función para enviar un lead a SaaS.
 *
 * @param {Object} lead - El objeto lead que contiene la información del lead.
 * @param {string} form_id - El ID del formulario.
 * @param {string} transaction_id - El ID de la transacción.
 * @param {string} request_status - El estado de la solicitud.
 * @param {string} model_form_description - La descripción del modelo de formulario.
 * @param {string} message_response - El mensaje de respuesta.
 * @returns {Promise} - Retorna una promesa que resuelve con la respuesta de la API.
 * @throws {Error} - Lanza un error si la solicitud falla.
 */
export const sendLeadToSaas = async (lead, form_id, transaction_id, request_status, model_form_description, message_response) => {
    try {
        const data = {
            lead,
            form_id,
            transaction_id,
            request_status,
            model_form_description,
            message_response
        }

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: "lead",
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data
        };
        const respuesta = clienteAxiosSaaSLog(config)

        return respuesta;
    } catch (error) {
        //Si existe un error
        console.log(error);
        throw error;
    }
};